function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.667 1.667H9.333L8.667 1H5.333l-.666.667H2.333V3h9.334M3 11.667A1.333 1.333 0 004.333 13h5.334A1.333 1.333 0 0011 11.667v-8H3v8z",
  fill: "currentColor"
});

var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgDelete;